import React from 'react';
import { Globe } from 'lucide-react';
import { PageHeader, Card, Empty } from '../ui';

export default function OsintPage() {
  return (
    <div>
      <PageHeader kicker="Open Source Intelligence" title="OSINT" />
      <Card>
        <Empty icon={Globe} title="Sezione in attivazione" text="Stiamo collegando il fornitore OSINT. Appena attivo potrai lanciare qui le ricerche e aggiungerle ai tuoi report." />
      </Card>
    </div>
  );
}
